import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { appInit } from 'moduleBase/actions/init';
import { REDUCER_GLOBAL_NAME } from 'moduleBase/constants';
import { ErrorBoundary, useErrorHandler } from 'react-error-boundary';
import MobileHeader from 'moduleBase/components/header/MobileHeader';
import { ApiError } from '@collaborator/npm_modules/dist/modules/base/errors/ApiError';
import AppRoutes from 'moduleBase/components/AppRoutes';
import { sweetAlertErrorShow } from '@collaborator/npm_modules/dist/components/sweetAlert/actions/show';
import { ErrorWithRedirect } from '@collaborator/npm_modules/dist/modules/base/errors/ErrorWithRedirect';
import Header from 'moduleBase/components/header/Header';
import ScrollToBlock from 'srcJs/components/scrollToBlock';
import DesktopNav from 'moduleBase/modules/menu/containers/DesktopNav';
import app from 'srcJs/App';
import { ErrorFallback } from 'moduleBase/components/ErrorFallback';
import classNames from 'classnames';
import { connect } from '@collaborator/npm_modules/dist/components/redux';
import reducerGlobal from 'moduleBase/reducers';
import { REDUCER_MENU_NAME } from 'moduleBaseMenu/constants';
import { reducerMenu } from 'moduleBaseMenu/reducers';
import { IntercomProvider } from 'components/intercom/components/IntercomProvider';
import { REDUCER_MENU_BALANCE_NAME } from 'moduleBase/modules/menu-balance/constants';
import { reducerMenuBalance } from 'moduleBase/modules/menu-balance/reducers';
import UserObserver from 'moduleBase/components/observers/UserObserver';
import ChatModal from 'moduleChat/modules/modal/container/ChatModal';
import { GoogleTagManagerProvider } from 'components/google-tag-manager/GoogleTagManagerProvider';
import { DataLayerObserver } from 'moduleBase/components/observers/DataLayerObserver';
import { SatisMeter } from 'components/satis-meter/SatisMeter';

var App = function App(_ref) {
  var init = _ref.init,
      isInit = _ref.isInit,
      userMenu = _ref.userMenu,
      alerts = _ref.alerts,
      isMainContentFullHeight = _ref.isMainContentFullHeight;
  var dispatch = useDispatch();
  var errorHandler = useErrorHandler();
  useEffect(function () {
    init().then();
    ScrollToBlock.init();
  }, []);
  useEffect(function () {
    if (app.isServe()) {
      return;
    }

    window.onunhandledrejection = function (promiseRejectionEvent) {
      var error = promiseRejectionEvent.reason;

      if (error instanceof ErrorWithRedirect) {
        window.location.href = error.redirectUrl;
        return;
      }

      if (!(error instanceof ApiError)) {
        errorHandler(error);
        return;
      }

      var _ref2 = error,
          message = _ref2.message;

      if (!message) {
        errorHandler(error);
        return;
      }

      dispatch(sweetAlertErrorShow({
        message: message
      }));
    };
  }, []);

  if (!isInit) {
    return null;
  }

  return /*#__PURE__*/React.createElement(GoogleTagManagerProvider, null, /*#__PURE__*/React.createElement(IntercomProvider, null, /*#__PURE__*/React.createElement(SatisMeter, null), /*#__PURE__*/React.createElement(UserObserver, null), /*#__PURE__*/React.createElement(DataLayerObserver, null), /*#__PURE__*/React.createElement("div", {
    id: "wrap",
    className: "page-layout"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-none d-xl-block"
  }, /*#__PURE__*/React.createElement(DesktopNav, null)), /*#__PURE__*/React.createElement("div", {
    className: "main custom-scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-xl-none"
  }, /*#__PURE__*/React.createElement(MobileHeader, {
    userMenu: userMenu
  })), /*#__PURE__*/React.createElement(Header, {
    userMenu: userMenu,
    alerts: alerts
  }), /*#__PURE__*/React.createElement(ErrorBoundary, {
    FallbackComponent: ErrorFallback
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('main__content', {
      'main__content_full-height': isMainContentFullHeight
    })
  }, /*#__PURE__*/React.createElement(AppRoutes, null)), /*#__PURE__*/React.createElement(ChatModal, null))))));
};

export default connect(App, {
  reducers: [{
    name: REDUCER_GLOBAL_NAME,
    reducer: reducerGlobal
  }, {
    name: REDUCER_MENU_NAME,
    reducer: reducerMenu
  }, {
    name: REDUCER_MENU_BALANCE_NAME,
    reducer: reducerMenuBalance
  }],
  mapStateToProps: function mapStateToProps(state) {
    return state[REDUCER_GLOBAL_NAME];
  },
  mapDispatchToProps: function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      init: appInit
    }, dispatch);
  }
});